import React, { ReactNode } from 'react';
import styled from '@emotion/styled';

import { BREAKPOINTS, GLOBAL_SIZES, CSS, STYLES } from '../../utils/consts';

type AsideProps = {
    children: ReactNode,
    flex?: boolean,
    right?: boolean,
    bottom?: boolean,
    center?: boolean,
    zIndex?: number,
}

function Aside({
    children,
    flex = false,
    right = false,
    bottom = false,
    center = false,
    zIndex = 0 }: AsideProps) {

    return (
        <AsideStyle flex={flex} right={right} bottom={bottom} center={center} zIndex={zIndex}>{children}</AsideStyle>
    )
}

export default Aside;

const AsideStyle = styled.aside<{ flex?: boolean, right?: boolean, bottom?: boolean, center?: boolean, zIndex?: number }>(({ flex, right, bottom, center, zIndex }) => `
    z-index: ${zIndex};
    position: absolute;
    pointer-events: none;
    ${bottom ? `bottom: ${right ? 96 : 40}px;` : ``}
    ${!bottom ? `top: 0;` : ``}
    ${(right || center) ? `right: 10px;` : ``}
    ${!right ? `left: ${STYLES.SIDEBAR_WIDTH+10}px;` : ``}
    ${flex ? `
        display: flex;
        justify-content: space-between;`: ''}
        @media (max-width: ${BREAKPOINTS.MOBILE}){
            ${!right ? `left: 12px;` : `right: 12px;`}
            ${bottom ? `bottom: ${right ? 132 : 16}px;` : `top: 12px;`}
    }
  }
`)